import axios from "axios";

export default {
	getTaskBank() {
		return axios.get(`/v3/taskbank`);
	},
	getPublicTaskBank(ref_id) {
		let config = {};
		config.headers = { "X-No-Timeout": true };

		return axios.get(`/v3/public_taskbank/${ref_id}`, config);
	},

	saveTaskBank(taskbank) {
		return axios.post("/v3/taskbank", taskbank);
	},

	RegisterTaskBankUser(bankuser) {
		let config = {};
		config.headers = { "X-No-Timeout": true };

		return axios.post("/v3/taskbank_user_registration", bankuser, config);
	},

	SaveTaskBankUser(bankuser) {
		let config = {};
		config.headers = { "X-No-Timeout": true };

		return axios.post("/v3/taskbank_user", bankuser, config);
	},
	SaveTaskBankComment(bankcomment) {
		let config = {};
		config.headers = { "X-No-Timeout": true };

		return axios.post("/v3/taskbank_comment", bankcomment, config);
	},

	GetTaskBankComments(taskID) {
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/taskbank_comment/${taskID}`, config);
	},
	LoginTaskBankUser(email, password) {
		let config = {};
		config.headers = { "X-No-Timeout": true };
		let user = {
			email: email,
			password: password
		}
		return axios.post("/v3/bank_auth", user, config);
	},

	getBankUser(bank_token) {
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/bank_user/${bank_token}`, config);

	},

	bankLogout(bank_token) {
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/bank_logout/${bank_token}`, config);

	},

	resetPassword(email) {
		let config = {};
		config.headers = { "X-No-Timeout": true };

		return axios.post("/v3/resetBankPassEmail", {
			email: email
		}, config);
	},

	setNewPassword(token, password) {
		let config = {};
		config.headers = { "X-No-Timeout": true };

		return axios.post("/v3/resetBankPass", {
			token: token,
			password: password
		}, config);
	},

	listAllComments(ctx) {
		return axios.get(`/v3/admin/bank_comments`, { params: ctx })
	},

	setCommentStatus(id, status) {
		return axios.post(`/v3/admin/bank_comment/${id}/status/${status}`)
	}
};



// WEBPACK FOOTER //
// ./src/services/TaskBankService.js